module.exports = __webpack_public_path__ + "static/media/T15.b67b1eee.mp4";